import React from "react";

import { DialogContent } from "@mui/material";
import DistanceMapView from "./DistanceMapView";
import Popup from "../../../../components/common/model/Popup";

interface Props {
  open: boolean;
  onHide: () => void;
  collections: any[];
  deliveries: any[];
}

const DistanceMapModal: React.FC<Props> = ({
  open,
  onHide,
  collections,
  deliveries,
}) => {
  return (
    <Popup
      open={open}
      title="Route Map"
      onHide={onHide}
      fullWidth
      maxWidth="lg"
      popupBg="#fff"
    >
      <DialogContent>
        <DistanceMapView
          collections={collections}
          deliveries={deliveries}
        />
      </DialogContent>
    </Popup>
  );
};

export default DistanceMapModal;
